<!-- Carrier Charges Tab Content -->
<div class="carrier-charges-tab-content">
  <!-- Title and Add Button -->
  <div class="d-flex justify-content-between align-items-center mb-3">
    <h5 class="mb-0">Carrier Charges ({{ carrierCharges.length }})</h5>
    <button class="btn btn-primary" (click)="openAddModal()">
      <i class="bi bi-plus-circle me-1"></i>Add Charge
    </button>
  </div>

  <!-- Empty State -->
  <div class="text-center py-5" *ngIf="carrierCharges.length === 0">
    <i class="bi bi-currency-dollar" style="font-size: 3rem; color: #dee2e6;"></i>
    <p class="text-muted mt-3">No carrier charges found</p>
    <button class="btn btn-link" (click)="openAddModal()">
      <i class="bi bi-plus me-1"></i>Create First Charge
    </button>
  </div>

  <!-- Table Structure -->
  <div class="table-responsive" *ngIf="carrierCharges.length > 0">
    <table class="table table-hover align-middle">
      <thead>
        <tr>
          <th>Carrier</th>
          <th>Charge Type</th>
          <th>Mode</th>
          <th>Route</th>
          <th>Rate</th>
          <th>Validity</th>
          <th>Actions</th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let charge of carrierCharges">
          <td><strong>{{ charge.carrierName || getCarrierName(charge.carrierId) }}</strong></td>
          <td>{{ charge.chargeTypeName || getChargeTypeName(charge.chargeTypeId) }}</td>
          <td>
            <span class="badge bg-primary">{{ charge.shipmentMode }}</span>
          </td>
          <td class="small">
            {{ charge.originPortName || getPortName(charge.originPortId) }} → {{ charge.destinationPortName || getPortName(charge.destinationPortId) }}
          </td>
          <td>
            <strong>{{ charge.currency }} {{ charge.rate | number:'1.2-2' }}</strong>
          </td>
          <td class="small">
            {{ formatDate(charge.validFrom) }}
            <span *ngIf="charge.validUntil"> - {{ formatDate(charge.validUntil) }}</span>
          </td>
          <td>
            <button class="btn btn-sm btn-link p-1" title="Edit" (click)="editCharge(charge)">
              <i class="bi bi-pencil"></i>
            </button>
            <button class="btn btn-sm btn-link text-danger p-1" title="Delete" (click)="deleteCharge(charge)">
              <i class="bi bi-trash"></i>
            </button>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</div>

<!-- Create/Edit Carrier Charge Modal -->
<div class="modal-backdrop fade show" *ngIf="showAddModal" style="z-index: 2000;"></div>
<div class="modal fade show d-block" *ngIf="showAddModal" tabindex="-1" role="dialog" style="z-index: 2001;">
  <div class="modal-dialog modal-lg modal-dialog-centered" role="document">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title">{{ isEditMode ? 'Edit' : 'Create' }} Carrier Charge</h5>
        <button type="button" class="btn-close" (click)="closeModal()"></button>
      </div>
      <div class="modal-body">
        <form>
          <!-- Row 1: Carrier and Charge Type -->
          <div class="row mb-3">
            <div class="col-md-6">
              <label class="form-label">Carrier <span class="text-danger">*</span></label>
              <select class="form-select" [(ngModel)]="formData.carrierId" name="carrierId" required>
                <option [ngValue]="undefined" disabled>Select carrier</option>
                <option *ngFor="let carrier of carriers" [ngValue]="carrier.id">{{ carrier.name }}</option>
              </select>
            </div>
            <div class="col-md-6">
              <label class="form-label">Charge Type <span class="text-danger">*</span></label>
              <select class="form-select" [(ngModel)]="formData.chargeTypeId" name="chargeTypeId" required>
                <option [ngValue]="undefined" disabled>Select charge type</option>
                <option *ngFor="let type of chargeTypes" [ngValue]="type.id">{{ type.name }}</option>
              </select>
            </div>
          </div>

          <!-- Row 2: Shipment Mode, Rate, Currency -->
          <div class="row mb-3">
            <div class="col-md-5">
              <label class="form-label">Shipment Mode <span class="text-danger">*</span></label>
              <select class="form-select" [(ngModel)]="formData.shipmentMode" name="shipmentMode" required>
                <option value="FCL">FCL</option>
                <option value="LCL">LCL</option>
                <option value="AIR">AIR</option>
                <option value="RORO">RORO</option>
              </select>
            </div>
            <div class="col-md-4">
              <label class="form-label">Rate <span class="text-danger">*</span></label>
              <input type="number" class="form-control" [(ngModel)]="formData.rate" name="rate" step="0.01" min="0" placeholder="0" required />
            </div>
            <div class="col-md-3">
              <label class="form-label">Currency</label>
              <select class="form-select" [(ngModel)]="formData.currency" name="currency">
                <option value="USD">USD</option>
                <option value="PHP">PHP</option>
              </select>
            </div>
          </div>

          <!-- Row 3: Origin and Destination Ports -->
          <div class="row mb-3">
            <div class="col-md-6">
              <label class="form-label">Origin Port</label>
              <select class="form-select" [(ngModel)]="formData.originPortId" name="originPortId">
                <option [ngValue]="undefined">Any Origin Port</option>
                <option *ngFor="let port of ports" [ngValue]="port.id">{{ port.name }} ({{ port.code }})</option>
              </select>
            </div>
            <div class="col-md-6">
              <label class="form-label">Destination Port</label>
              <select class="form-select" [(ngModel)]="formData.destinationPortId" name="destinationPortId">
                <option [ngValue]="undefined">Any Destination Port</option>
                <option *ngFor="let port of ports" [ngValue]="port.id">{{ port.name }} ({{ port.code }})</option>
              </select>
            </div>
          </div>

          <!-- Row 4: Valid From and Valid Until -->
          <div class="row mb-3">
            <div class="col-md-6">
              <label class="form-label">Valid From <span class="text-danger">*</span></label>
              <input type="date" class="form-control" [(ngModel)]="formData.validFrom" name="validFrom" required />
            </div>
            <div class="col-md-6">
              <label class="form-label">Valid Until</label>
              <input type="date" class="form-control" [(ngModel)]="formData.validUntil" name="validUntil" />
            </div>
          </div>

          <!-- Row 5: Notes -->
          <div class="mb-3">
            <label class="form-label">Notes</label>
            <textarea
              class="form-control"
              rows="3"
              [(ngModel)]="formData.notes"
              name="notes"
              placeholder="Additional notes or remarks"
            ></textarea>
          </div>
        </form>
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-secondary" (click)="closeModal()">Cancel</button>
        <button type="button" class="btn btn-primary" (click)="saveCharge()">
          {{ isEditMode ? 'Update' : 'Create Charge' }}
        </button>
      </div>
    </div>
  </div>
</div>
